<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

  @if (draft) {
    <app-page-detail-hero [auditStamp]="draft"
      icon="pi pi-file-edit"
      eyebrow="Storage Billing Draft"
      [title]="draft.draftNumber || 'Billing Draft'"
      [subtitle]="clientName(draft.crmClientId) + ' | ' + draft.billingStartDate + ' to ' + draft.billingEndDate">
      <div tags>
        <p-tag [value]="draft.status" [severity]="statusSeverity(draft.status)"></p-tag>
        <p-tag [value]="draft.currency || 'SAR'" severity="secondary"></p-tag>
        @if (draft.invoiceNumber) {
          <p-tag [value]="draft.invoiceNumber" severity="success"></p-tag>
        }
      </div>
      <div actions>
        <app-execution-sales-order-button *ngIf="draft.status === 'DRAFT'" sourceType="WAREHOUSE_BILLING_DRAFT"
          [sourceId]="draft.id" [owningCompanyId]="owningCompanyId()" [sourceLabel]="draft.draftNumber"></app-execution-sales-order-button>
        <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/warehousing/billing-drafts"></p-button>
        <p-button label="Edit" icon="pi pi-pencil" severity="info" [routerLink]="['/warehousing/billing-drafts/edit', draft.id]" *ngIf="!isEditMode && draft.status === 'DRAFT'"></p-button>
        <p-button label="Add Manual Line" icon="pi pi-plus" severity="secondary" [outlined]="true" (click)="addManualLine()" [disabled]="!isEditMode || draft.status !== 'DRAFT'"></p-button>
        <p-button label="Save Draft" icon="pi pi-save" [loading]="isSaving" (click)="saveDraft()" [disabled]="isSaving || !isEditMode || draft.status !== 'DRAFT'"></p-button>
        <p-button label="Post Invoice" icon="pi pi-file" severity="success" [loading]="isSaving" (click)="postDraft()" [disabled]="isSaving || draft.status !== 'DRAFT'"></p-button>
      </div>
    </app-page-detail-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-form-section icon="pi pi-calendar" title="Billing Header" subtitle="Billing period, customer, and invoice reference.">
      <div class="warehousing-detail-list">
        <div><span>Client</span><strong>{{ clientName(draft.crmClientId) }}</strong></div>
        <div><span>Account ID</span><strong>{{ draft.crmAccountId || '-' }}</strong></div>
        <div><span>Billing Period</span><strong>{{ draft.billingStartDate }} to {{ draft.billingEndDate }}</strong></div>
        <div><span>Posted Invoice</span><strong>{{ draft.invoiceNumber || '-' }}</strong></div>
        <div><span>Notes</span><strong>{{ draft.notes || '-' }}</strong></div>
      </div>
    </app-page-form-section>

    <app-page-data-panel title="Billing Lines" subtitle="Chargeable storage areas, rates, and edited amounts." [resultText]="(draft.lines?.length || 0) + ' records'">
      <p-table [value]="draft.lines || []" styleClass="p-datatable-sm p-datatable-gridlines warehousing-data-table" [tableStyle]="{ 'min-width': '72rem' }">
        <ng-template pTemplate="header"><tr><th>Description</th><th>Metric</th><th class="text-right">Qty Days</th><th class="text-right">Area</th><th class="text-right">Rate</th><th class="text-right">Edited Amount</th></tr></ng-template>
        <ng-template pTemplate="body" let-line>
          <tr>
            <td><input pInputText [(ngModel)]="line.description" class="w-full" [disabled]="!isEditMode || draft.status !== 'DRAFT'"></td>
            <td>{{ line.metric }}</td>
            <td class="text-right"><input pInputText type="number" [(ngModel)]="line.quantityDays" class="w-6rem text-right" [disabled]="!isEditMode || draft.status !== 'DRAFT'"></td>
            <td class="text-right"><input pInputText type="number" [(ngModel)]="line.chargeableArea" class="w-6rem text-right" [disabled]="!isEditMode || draft.status !== 'DRAFT'"></td>
            <td class="text-right"><input pInputText type="number" [(ngModel)]="line.ratePerDay" class="w-6rem text-right" [disabled]="!isEditMode || draft.status !== 'DRAFT'"></td>
            <td class="text-right"><input pInputText type="number" [(ngModel)]="line.editedAmount" class="w-7rem text-right" [disabled]="!isEditMode || draft.status !== 'DRAFT'"></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage"><tr><td colspan="6"><div class="warehousing-empty-state"><i class="pi pi-search"></i><strong>No billing lines</strong><span>No lines were generated for this draft.</span></div></td></tr></ng-template>
      </p-table>
    </app-page-data-panel>
  } @else if (!isLoading) {
    <div class="warehousing-empty-detail">
      <i class="pi pi-search"></i>
      <strong>Billing draft not found</strong>
      <span>The selected billing draft could not be loaded.</span>
    </div>
  }
</app-page-shell>
